<template>
    <div>
        <div class="card">
            <div class="header">我的资料</div>
            <div class="card-txt">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <span class="title">会员帐号</span>
                            <span class="content">{{myInfos.phoneNumber}}</span>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <span class="title">会员昵称</span>
                            <span class="content">{{myInfos.name}}</span>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <span class="title">会员等级</span>
                            <span class="content">{{myInfos.levelDesc}}</span>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <span class="title">我的积分</span>
                            <span class="content money">{{myInfos.integral}}</span>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <span class="title">我的现金券</span>
                            <span class="content money">$ {{myInfos.cash}}</span>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <span class="title">我的优惠券</span>
                            <span class="content link" @click="isShowCoupons = true">查看 <i class="el-icon-arrow-right"></i></span>
                        </el-card>
                    </el-col>
                </el-row>
                <div class="btn">
                    <button @click="showMaterial()"><i class="el-icon-s-custom"></i>修改资料</button>
                    <button style="margin-left: 12px;" @click="$router.push({path: '/password'})"><i class="el-icon-edit-outline"></i>修改密码</button>
                </div>
            </div>
        </div>
        <el-dialog title="我的优惠券" top="5vh" :visible.sync="isShowCoupons" width="600px"
            :close-on-click-modal="false" @closed="isShowCoupons=false">
            <mycoupons :randomVal="Math.random()" v-on:immediateUse="immediateUse"></mycoupons>
        </el-dialog>
        <el-dialog title="修改个人资料" top="5vh" :visible.sync="isShowMaterial" width="500px"
            :close-on-click-modal="false" @closed="isShowCoupons=false" @open="getUpdateInfo()">
            <el-form :model="myMaterial" :rules="rules" label-width="100px" ref="loginForm">
                <el-form-item label="昵称">
                    <el-input placeholder="请输入昵称" v-model="myMaterial.name" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="寄件人姓名">
                    <el-input placeholder="请输入寄件人姓名" v-model="myMaterial.consignor && myMaterial.consignor.name" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input placeholder="请输入电话" v-model="myMaterial.consignor && myMaterial.consignor.tel" maxlength="11"></el-input>
                </el-form-item>
                <!--<el-form-item label="邮箱地址">
                    <el-input placeholder="请输入邮箱地址" v-model="myMaterial.emailAddress"></el-input>
                </el-form-item>-->
            </el-form>
            <div slot="footer">
                <el-button @click="isShowMaterial = false">取 消</el-button>
                <el-button type="primary" @click="updateMyInfo()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import mycoupons from '@/views/frontend/components/myCoupons.vue'
    export default {
        name: 'myCenter',
        components: {
            mycoupons
        },
        data () {
            return {
                isShowCoupons: false,
                isShowMaterial: false,
                myInfos: {},
                myMaterial: {},
                rules: {}
            }
        },
        mounted() {
            this.getMyInfo();
        },
        methods: {
            getMyInfo() {
                this.showPcLoading();
                this.$axios.get(window.consts.apis.getMyInfo, {}).then(r=>{
                    this.hidePcLoading();
                    if(r.success){
                        this.myInfos = r.result;
                        this.getUpdateInfo();
                    } else {
                        this.$alert(r.error.message,'');
                    }
                }).catch(e => {
                    this.hidePcLoading();
                    this.$message.error("加载数据失败!");
                })
            },
            getUpdateInfo() {
                this.myMaterial = JSON.parse(JSON.stringify(this.myInfos));
            },
            showMaterial() {
                this.isShowMaterial = true;
            },
            updateMyInfo() {
                let info = {
                    name: this.myMaterial.name,
                    emailAddress: this.myMaterial.emailAddress,
                    consignor: {
                        name: this.myMaterial.consignor.name,
                        tel: this.myMaterial.consignor.tel
                    }
                }
                var valid = window.consts.validate
                if(!info.name) {
                    this.$message.error("请输入昵称!");
                    return false
                } else if (!info.consignor.name) {
                    this.$message.error("请输入寄件人姓名!");
                    return false
                } else if(!info.consignor.tel) {
                    this.$message.error("电话号码格式错误!");
                    return false
                } 
                /*else if (!valid.email.test(info.emailAddress)) {
                    this.$message.error("邮箱地址格式错误!");
                    return false
                }*/
                this.showPcLoading();
                this.$axios.put(window.consts.apis.updateMyInfo, info).then(res => {
                    this.hidePcLoading();
                    if (res.success) {
                        this.$notify({
                            title: '提示',
                            message: '资料修改成功',
                            type: 'success',
                            duration: 2000,
                            onClose: (rt => {
                                this.getMyInfo();
                                this.isShowMaterial = false;
                            })
                        })
                    } else {
                        this.$alert(res.error.message,'');
                    }
                }).catch(e => {
                    this.$message.error("出错啦，请稍候再试!");
                    this.hidePcLoading();
                })
            },
            immediateUse(data) {
                this.$router.push({ path: "/" });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        width: 800px;
        margin: 40px auto;
        box-shadow: 0 0 10px #ddd;

        .header {
            font-size: 18px;
            padding: 20px 30px;
            border-bottom: 1px solid #eee;
        }

        .card-txt {
            padding: 20px 30px;

            ::v-deep .el-input__inner {
                height: 44px;
                line-height: 44px;
            }

            ::v-deep .el-form-item {
                margin-bottom: 30px;
            }

            .btn{
                text-align: right;
                padding: 0 0 10px 0;
                button{
                    width: 120px;
                    height: 44px;
                    line-height: 44px;
                    background: #90ca6f;
                    color: white;
                }
            }
        }
        .title {
            font-weight: bold;
        }
        .content {
            float:right;
            color: #333;
        }
        .content.money {
            color: #ff0000;
        }
        .content.link {
            cursor: pointer;
            color:#999;
        }
    }

</style>
